import { AbstractControl, ValidationErrors } from '@angular/forms';

export const packageValidator = (control: AbstractControl): ValidationErrors | null => {
  const packageWidth = control.get('packageWidth')?.value;
  const packageHeight = control.get('packageHeight')?.value;
  const packageLength = control.get('packageLength')?.value;
  const packageCapacity = control.get('packageCapacity')?.value;

  const hasAnyPackageField = packageWidth || packageHeight || packageLength || packageCapacity;

  if (hasAnyPackageField) {
    const allPackageFieldsFilled = packageWidth && packageHeight && packageLength && packageCapacity;

    if (!allPackageFieldsFilled) {
      return { packageIncomplete: true };
    }
  }

  return null;
};
